import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { get, isEmpty } from 'lodash';
import { Timeline, Row, Col, Tooltip, Avatar, Modal, Spin } from 'antd';
import {
  DesktopOutlined,
  TabletOutlined,
  MobileOutlined,
  FileImageOutlined,
} from '@ant-design/icons';

const { Item } = Timeline;

const ImpressionTimeline = ({ transactionId, getImpressions }) => {
  const [impressionsData, setImpressionsData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentImpression, setCurrentImpression] = useState(null);
  const [isFetching, setIsFetching] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (transactionId) {
      setIsFetching(true);
      setHasError(false);

      getImpressions({ variables: { id: transactionId } })
        .then((result) => {
          const impressions = result?.data?.campaignOrderTransactionsImpressionses;
          setImpressionsData(impressions);
          setIsFetching(false);
        })
        .catch((error) => {
          console.error('Error fetching impressions:', error);
          setHasError(true);
          setIsFetching(false);
          setImpressionsData([]);
        });
    }
  }, [transactionId, getImpressions]);

  const showModal = (impression) => {
    if (impression.media) {
      setIsModalVisible(true);
      setCurrentImpression(impression);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const getIcon = (platform) => {
    const lowerPlatform = (platform || '').toLowerCase();

    if (lowerPlatform.includes('ipad') || lowerPlatform.includes('tablet')) {
      return <TabletOutlined />;
    }
    if (
      lowerPlatform.includes('iphone') ||
      lowerPlatform.includes('android') ||
      lowerPlatform.includes('mobile')
    ) {
      return <MobileOutlined />;
    }
    return <DesktopOutlined />;
  };

  if (isFetching) {
    return (
      <Row type="flex" justify="center" align="middle" style={{ padding: '40px' }}>
        <Spin size="large" tip="Loading impressions..." />
      </Row>
    );
  }

  if (hasError) {
    return (
      <Row type="flex" justify="center" align="middle" style={{ padding: '40px' }}>
        <div style={{ color: '#ff4d4f', fontSize: '14px' }}>
          Error loading impressions. Please try again.
        </div>
      </Row>
    );
  }

  if (isEmpty(impressionsData)) {
    return (
      <Row type="flex" justify="center" align="middle" style={{ padding: '40px' }}>
        <div style={{ color: '#595959', fontSize: '14px' }}>
          No impressions found for this transaction.
        </div>
      </Row>
    );
  }

  const makeTimeLine = impressionsData.map((impression, i) => {
    const {
      impressionTime,
      impressionPublisherPlatform,
      impressionPublisherUrl,
      impressionPublisher,
      impressionPublisherMedia,
      media,
      eventId,
    } = impression;

    const platform = impressionPublisherPlatform || 'Unknown';
    const publisher = impressionPublisher || 'Unknown Publisher';
    const publisherUrl = impressionPublisherUrl || '';

    return (
      <Item key={i}>
        <Row>
          <Col span={6}>
            <div>
              <Avatar
                shape="square"
                alt={eventId}
                size={50}
                icon={<FileImageOutlined />}
                onClick={() => showModal(impression)}
                src={media || false}
                style={{ cursor: media ? 'pointer' : 'default' }}
              />
            </div>
            <div
              style={{
                fontFamily: 'roboto',
                fontSize: '105%',
                fontWeight: 700,
                color: '#636363',
                marginTop: '8px',
              }}
            >
              {`Impression served - ${moment(impressionTime).format('MM/DD/YY HH:mm:ss')}`}
            </div>
          </Col>
          <Col span={6}>
            <div
              style={{
                fontFamily: 'roboto',
                fontSize: '105%',
                fontWeight: 700,
                color: '#636363',
              }}
            >
              {getIcon(platform)}
              <Tooltip title={platform}>{`  ${platform}`}</Tooltip>
            </div>
          </Col>
          <Col span={6}>
            <div
              style={{
                fontFamily: 'roboto',
                fontSize: '105%',
                fontWeight: 700,
                color: '#636363',
                overflow: 'hidden',
              }}
            >
              <div
                style={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                <Tooltip title={publisherUrl || publisher}>{publisher}</Tooltip>
              </div>
              {publisherUrl && (
                <div style={{ marginTop: '4px', fontSize: '90%', color: '#999' }}>
                  <a href={publisherUrl} target="_blank" rel="noopener noreferrer">
                    Visit
                  </a>
                </div>
              )}
            </div>
          </Col>
          <Col span={6}>
            {impressionPublisherMedia && (
              <Avatar
                shape="square"
                size={50}
                src={impressionPublisherMedia}
                icon={<FileImageOutlined />}
              />
            )}
          </Col>
        </Row>
      </Item>
    );
  });

  return (
    <div style={{ marginRight: 100 }}>
      <Modal
        title={currentImpression?.eventId || 'Impression'}
        visible={isModalVisible}
        footer={null}
        onCancel={handleCancel}
      >
        {currentImpression?.media && (
          <img src={currentImpression.media} alt={currentImpression.eventId} width="100%" />
        )}
      </Modal>
      <Timeline mode={'left'} reverse={true}>
        {makeTimeLine}
      </Timeline>
    </div>
  );
};

export default ImpressionTimeline;
